module.exports = __webpack_public_path__ + "static/media/iconCommitSweep.4dd8f787.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconCommitSweep.svg
// module id = 947
// module chunks = 0